import React from 'react';
import { connect, ResolveThunks } from 'react-redux';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import { IconButton, Tooltip } from '@mui/material';

import { showDocumentTools } from '../../actions/documentTools';

type DispatchProps = ResolveThunks<typeof actionCreators>;
type Props = DispatchProps;

function ReorderDocuments({ onLaunchDocumentTools }: Props) {
  return (
    <div>
      <Tooltip disableInteractive disableFocusListener id="reorder-tooltip" title="Reorder Documents">
        <IconButton onClick={onLaunchDocumentTools} aria-label="Reorder Documents" sx={{ borderRadius: 0 }}>
          <ImportExportIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
}

const actionCreators = {
  onLaunchDocumentTools: showDocumentTools,
};

export default connect(null, actionCreators)(ReorderDocuments);
